import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ClassroomFilterDto } from 'src/app/data/models/dto/classroom-filter.dto';
import { UserUtil } from 'src/app/data/utils/user.utils';
import { SimpleNode } from 'src/app/ui/components/select-hierarquical-list/model/simple.node.interface';
import { Show } from '../../../models/show.interface';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';
import { ImageItem } from 'src/app/ui/components/select-simple-list/model/item-image.interface';
import { ExcludeProfessorAndEmployees, formatSelectedProfilesText } from 'src/app/data/utils/profile.utils';
import { ClassRoomTree } from 'src/app/data/models/interfaces/class-room-tree.interface';
import { ProfileService } from 'src/app/data/services/profile.service';

@Component({
  selector: 'app-show-second-step',
  templateUrl: './show-second-step.component.html',
  styleUrls: ['./show-second-step.component.scss']
})
export class ShowSecondStepComponent implements OnInit {
  classroomsList: string[] = [];
  profilesPlaceholder = '';
  profilesSelectAllText = 'Todos os perfis';
  selectedIdsProfiles: string[] = [];
  startTxtYear = '';
  segmentTreeData: SimpleNode[] = [];
  selectedIdsClassrooms: string[] = [];
  excludeProfiles = ExcludeProfessorAndEmployees;
  filter: ClassroomFilterDto | undefined

  @Input() secondFormGroup: FormGroup = this.fb.group({});
  @Input() show: Show | undefined;

  constructor(
    private readonly fb: FormBuilder,
    private readonly userUtil: UserUtil,
    private readonly classroomsService: ClassRoomsService,
    private readonly profileService: ProfileService,

  ) { }

  private get schools() {
    return this.userUtil.getSchools();
  }

  async ngOnInit(): Promise<void> {
    this.filter = {
      year: this.startTxtYear,
      idSchool: this.schools[0].id,
    };
    this.startTxtYear = new Date().getFullYear().toString();
    if (this.show) {
      this.selectedIdsClassrooms = this.show!.idsClassrooms;
      this.selectedIdsProfiles = this.show!.idsProfiles;
      this.secondFormGroup.controls['year'].setValue(this.show.year);
      this.secondFormGroup.controls['idsProfiles'].setValue(this.selectedIdsProfiles);
      this.loadFormProfiles();
    }
    else {
      this.secondFormGroup.controls['year'].setValue(this.startTxtYear);
    }
    this.loadSegmentTree(this.filter);
  }

  async getYearSelected(year: string) {
    this.show!.year = year;
    this.secondFormGroup.controls['year'].setValue(year);
    this.secondFormGroup.controls['idsClassrooms'].setValue('');
    this.segmentTreeData = [];

    this.filter = {
      year: year,
      idSchool: this.schools[0].id,
    };
  }

  private async loadSegmentTree(filter: ClassroomFilterDto): Promise<void> {
    const tree = await this.classroomsService.getTree(filter).toPromise();
    this.segmentTreeData = tree.map((seg) => ({
      id: seg.id,
      name: seg.name,
      children: seg.series.map((ser) => ({
        name: ser.name,
        children: ser.classRooms.map((cls) => ({
          id: cls.id,
          name: cls.name,
        })),
      })),
    }));
    let classrooms: ClassRoomTree[] = [];
    tree.forEach((node) =>
      node.series.forEach((serie) =>
        serie.classRooms.forEach((classroom) => {
          if (this.show?.idsClassrooms?.includes(classroom.id)) {
            classrooms.push(classroom);
          }
        })
      )
    );
    this.handleSelectClassroom(classrooms);
  }

  openList(evt: any, trigger: MatAutocompleteTrigger): void {
    if (this.secondFormGroup.enabled) {
      evt.stopPropagation();
      if (trigger.panelOpen) {
        trigger.closePanel();
      } else {
        trigger.openPanel();
      }
    }
  }

  handleSelectClassroom(classrooms: any) {
    const ids = classrooms.map((classroom: any) => classroom.id);
    this.selectedIdsClassrooms = ids;
    const names = classrooms.map((classroom: any) => classroom.name);
    this.secondFormGroup.controls['idsClassroomsText'].setValue(
      this.formatSelectedClassroomsText(names)
    );
    this.secondFormGroup.controls['idsClassrooms'].setValue(
      this.selectedIdsClassrooms
    );
    this.secondFormGroup.markAsDirty();
  }

  private formatSelectedClassroomsText(classrooms: string[]): string {
    let classroomsText = '';
    if (classrooms.length >= 1) {
      classroomsText = classrooms[0];
      if (classrooms.length > 1) {
        classroomsText = classroomsText
          .concat(' +')
          .concat((classrooms.length - 1).toString());
      }
    }
    return classroomsText;
  }

  private async loadFormProfiles() {
    const result = await this.profileService.getAll().toPromise();

    const profiles = result.map(
      (profile) =>
        <ImageItem>{
          id: profile.id,
          imageUrl: '',
          name: profile.name,
          isChecked: this.selectedIdsProfiles.includes(profile.id!),
        }
    );

    const profileNames = formatSelectedProfilesText(profiles);
    this.secondFormGroup.controls['idsProfilesText'].setValue(profileNames);
  }

  handleProfileSelect(profiles: ImageItem[]): void {
    const selectedProfiles = profiles.filter((item) => item.isChecked);
    const ids = selectedProfiles.map((evt) => evt.id);
    this.selectedIdsProfiles = ids as string[];
    const selectedProfilesText = formatSelectedProfilesText(profiles);
    this.secondFormGroup.controls['idsProfilesText'].setValue(selectedProfilesText);
    this.secondFormGroup.controls['idsProfiles'].setValue(this.selectedIdsProfiles);
    this.secondFormGroup.markAsDirty();
  }
}
